import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import ChooseSaca from "../components/ChooseSaca";
import EventsLanding from "../components/EventsLanding";
import Faqs from "../components/Faqs";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import LandingStats from "../components/LandingStats";
import LeagueLanding from "../components/LeagueLanding";
import MatchLanding from "../components/MatchLanding";
import Navbar from "../components/Navbar";
import PitchLanding from "../components/PitchLanding";
import Sub from "../components/Pricing";
import TallyFormSection from "../components/TallyFormSection";
import Testimonial from "../components/Testimonial";
import TournamentsLanding from "../components/TournamentsLanding";

const Landing: React.FC = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("matches");

    const tabs = [
        { id: "matches", label: "Matches", component: <MatchLanding /> },
        { id: "pitches", label: "Pitches", component: <PitchLanding /> },
        { id: "leagues", label: "Leagues", component: <LeagueLanding /> },
        { id: "tournaments", label: "Tournaments", component: <TournamentsLanding /> },
        { id: "events", label: "Events", component: <EventsLanding /> },
    ];

    useEffect(() => {
        const navigationState = location.state as { activeTab?: string; scrollTo?: string } | null;
        const requestedTab = navigationState?.activeTab;

        if (requestedTab && tabs.some((tab) => tab.id === requestedTab)) {
            setActiveTab(requestedTab);
            globalThis.setTimeout(() => {
                document.getElementById(navigationState?.scrollTo || "explore-section")
                    ?.scrollIntoView({ behavior: "smooth" });
            }, 50);
            return;
        }

        globalThis.scrollTo(0, 0);
    // tabs are a static page definition; location keys represent real navigations.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key]);

    return (
        <div className="min-h-screen bg-white font-Manrope selection:bg-green-100 selection:text-green-900">
            <Navbar />
            <Hero />

            {/* Dynamic Content Section */}
            <section id="explore-section" className="py-24 bg-gray-50/50 scroll-mt-20">
                <div className="max-w-7xl mx-auto px-4 md:px-14">
                    <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 mb-16">
                        <div className="space-y-4">
                            <h3 className="text-green-700 font-black uppercase tracking-[0.2em] text-sm">Explore SACA</h3>
                            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight">
                                Your Path to <br /><span className="text-green-700">Playing Excellence</span>
                            </h2>
                        </div>

                        <div className="flex flex-wrap gap-2 bg-white p-2 rounded-[24px] shadow-xl border border-gray-100/50">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`px-8 py-4 rounded-2xl font-black transition-all duration-300 ${activeTab === tab.id
                                        ? "bg-green-700 text-white shadow-lg shadow-green-200 scale-105"
                                        : "text-gray-400 hover:text-gray-600 hover:bg-gray-50"
                                        }`}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="transition-all duration-500 transform">
                        {tabs.find((tab) => tab.id === activeTab)?.component}
                    </div>
                </div>
            </section>

            <TallyFormSection />
            <ChooseSaca headings={[]} />
            <LandingStats />
            <Sub headings={[]} />
            <Testimonial headings={[]} />
            <Faqs headings={[]} />
            <Footer />
        </div>
    );
};

export default Landing;
